import { render, staticRenderFns } from "./AppLevelBadge.vue?vue&type=template&id=4f1ef3a1&scoped=true"
import script from "./AppLevelBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppLevelBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppLevelBadge.vue?vue&type=style&index=0&id=4f1ef3a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1ef3a1",
  null
  
)

export default component.exports